<div class="dos-base px-4 py-4 tabular-nums bg-theme-receipt-bg text-theme-receipt-text" [class]="textSize" *ngIf="printInstructions">
  <div *ngFor="let inst of printInstructions" [ngClass]="inst.tclass">
    <div *ngIf="inst.temp == 'div'">
      <div class="border-b h-1 border-theme-receipt-text opacity-40 my-3"></div>
    </div>
    <div *ngIf="inst.temp == 'center'" class="dos-center">
      {{inst.text?.center}}
    </div>
    <div *ngIf="inst.temp == 'row'" class="dos-row">
      <div [innerHTML]="inst.text?.left" style="margin-right: auto;"></div>
      <div [innerHTML]="inst.text?.center"></div>
      <div [innerHTML]="inst.text?.right" style="margin-left: auto;"></div>
    </div>
    <div *ngIf="inst.temp == 'row5-5-8'" class="dos-row">
      <div [innerHTML]="inst.text?.left" style="flex: 10;"></div>
      <div [innerHTML]="inst.text?.center" style="flex: 10;text-align: end;"></div>
      <div [innerHTML]="inst.text?.right" *ngIf="inst.text?.right" style="flex: 16;text-align: end;"></div>
    </div>
    <div *ngIf="inst.feed" [ngStyle]="{'height':inst.feed+'px'}"></div>
    <div *ngIf="inst.qr" class="py-3 text-center">
      @if (isReviewQr(inst.qr.data)) {
        <a [href]="inst.qr.data" target="_blank" class="inline-flex flex-col items-center gap-2 p-4 rounded-xl bg-theme-receipt-text no-underline">
          <img [src]="getQrImageUrl(inst.qr.data)" alt="QR" class="rounded max-w-40" />
          <span class="text-theme-receipt-bg font-semibold text-base flex items-center gap-2">
            <i class="fa-solid fa-star"></i>
            {{translate.getString('Lämna omdöme')}}
            <i class="fa-solid fa-arrow-up-right-from-square text-sm"></i>
          </span>
        </a>
      } @else {
        <img [src]="getQrImageUrl(inst.qr.data)" alt="QR" class="mx-auto rounded max-w-40" />
      }
    </div>
  </div>
</div>
